import * as actions from './organizationHoliday.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { HolidayModel } from '@smarttask-common/src/lib/models/Resource/HolidayModel';

export const holidayAdapter = createEntityAdapter<HolidayModel>({
    selectId: (x) => x.holiday_id,
});
export interface HolidayState extends EntityState<HolidayModel> {
    selected_holiday_id: string;
}

export const initialState: HolidayState = holidayAdapter.getInitialState({
    selected_holiday_id: undefined,
});

export function HolidayReducers(state: HolidayState = initialState, action: actions.HolidayActions) {
    switch (action.type) {
        case actions.HolidayActionTypes.UPDATE_SELECTED_HOLIDAY:
            state = { ...state, selected_holiday_id: action.selected_holiday_id };
            //console.log(state);
            return state;

        case actions.HolidayActionTypes.ADD_HOLIDAY:
            return holidayAdapter.addOne(action.holiday, state);

        case actions.HolidayActionTypes.ADD_HOLIDAYS:
            return holidayAdapter.addMany(action.holidays, state);

        case actions.HolidayActionTypes.UPSERT_HOLIDAY:
            return holidayAdapter.upsertOne(action.holiday, state);

        case actions.HolidayActionTypes.UPSERT_HOLIDAYS:
            return holidayAdapter.upsertMany(action.holidays, state);

        case actions.HolidayActionTypes.UPDATE_HOLIDAY:
            return holidayAdapter.updateOne(action.holiday, state);

        case actions.HolidayActionTypes.UPDATE_HOLIDAYS:
            return holidayAdapter.updateMany(action.holidays, state);

        case actions.HolidayActionTypes.DELETE_HOLIDAY:
            return holidayAdapter.removeOne(action.id, state);

        case actions.HolidayActionTypes.DELETE_HOLIDAYS:
            return holidayAdapter.removeMany(action.ids, state);

        case actions.HolidayActionTypes.DELETE_ALL_HOLIDAYS:
            return holidayAdapter.removeMany(action.ids, state);

        case actions.HolidayActionTypes.DELETE_ALL:
            return holidayAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getHolidayState = createFeatureSelector<HolidayState>('holiday');

export const { selectIds, selectEntities, selectAll, selectTotal } = holidayAdapter.getSelectors(getHolidayState);

const getSelectedHolidayIdState = (state: HolidayState) => {
    return state.selected_holiday_id;
};
export const getSelectedHolidayId = createSelector(getHolidayState, getSelectedHolidayIdState);

export const getSelectedHoliday = createSelector(getHolidayState, (state: HolidayState) => {
    if (state.selected_holiday_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_holiday_id];
});
